<template>
  <div :id="id" :style="style"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'CustomPie',
  props: {
    id: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '58px'
    },
    percent: {
      type: Number,
      required: true,
      default: 89
    },
  },
  data() {
    return {
      style: {
        'min-width': this.width,
        height: this.width,
        'margin-left': '-18px'
      }
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chart = echarts.init(document.getElementById(this.id))
      const data = [
        { value: this.percent, name: 'XXX', itemStyle: { color: 'rgba(55, 110, 255, 1)' } },
        { value: 100 - this.percent, name: 'XXX', itemStyle: { color: '#efefef' } }
      ]
      const total = data.reduce((sum, item) => sum + item.value, 0)
      const initialPercentage = ((data[0].value / total) * 100).toFixed(0)

      const option = {
        tooltip: {
          // trigger: 'item'
          show: false
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['53%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data
          }
        ],
        graphic: {
          elements: [
            {
              type: 'text',
              left: 'center',
              top: 'center',
              style: {
                text: initialPercentage + '%',
                textAlign: 'center',
                fill: '#000',
                fontSize: 12
              }
            }
          ]
        }
      }
      chart.setOption(option)
    }
  }
}
</script>